import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65d0489a"
import script from "./assetAllocation.js?vue&type=script&lang=js&external"
export * from "./assetAllocation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports